type TFunction = (key: string) => string;

export const validateExtensionPhone = (phone: string, t: TFunction) => {
  const digits = phone.replace(/\D/g, '');

  if (!digits) return t('cardExtension.phoneValidation.required');
  if (!/^\d{9}$/.test(digits)) return t('cardExtension.phoneValidation.invalid');

  return null;
};

export const isPhoneValid = (phone: string) => /^\d{9}$/.test(phone.replace(/\D/g, ''));
